// Injected at build time from package.json (see vite.config.ts `define`)
export const APP_VERSION: string = __APP_VERSION__;
